import { parse, stringify } from 'jsurl2';
import { isEmpty, isObject, isString } from 'lodash-es';

export const getUrlParams = (str: string) => {
  const params = Object.fromEntries(new URLSearchParams(str));

  return params;
};

export const packObjectToURIComponent = (obj: Record<string | number, unknown> | unknown[]) => {
  if (!isObject(obj) || isEmpty(obj)) {
    return null;
  }

  let res = null;

  try {
    res = stringify(obj);
  } catch (error) {
    console.error('Failed to pack obj', obj);
  }

  return res;
};

export const unpackURIComponentToObject = <T>(str: string | null) => {
  if (!isString(str) || str === '' || !str.endsWith('~')) {
    return null;
  }

  let res = null;

  try {
    res = parse<T>(str);
  } catch (error) {
    console.error('Failed to unpack str', str);
  }

  return res;
};

export const expandParameterMap = (parameterMap: Record<string, unknown>): URLSearchParams => {
  const params = new URLSearchParams();

  Object.entries(parameterMap).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        // Add each array item as a separate parameter with the same name
        value.forEach((item) => {
          params.append(key, String(item));
        });
      } else {
        params.append(key, String(value));
      }
    }
  });

  return params;
};
